import React, { Component } from 'react';
import { SplitLayoutSide, SplitLayoutVariant } from './splitLayout.constants';
import SplitLayoutController from './SplitLayout.controller';
import Inherit from '../../../../core/inherit';

/**
 * Full-viewport split shell: form/content column + optional marketing/media column.
 *
 * @param {object} props
 * @param {React.ReactNode} props.children — main column body (scrolls / centers)
 * @param {React.ReactNode} [props.side] — second column (hero / marketing)
 * @param {string} [props.sideVariant] — {@link SplitLayoutSide} (`left` | `right`)
 * @param {string} [props.variant] — {@link SplitLayoutVariant} (`default` ~40/60, `equal` 50/50, `twoThirds` ~67/33)
 * @param {boolean} [props.embedded] — flush shell inside admin `Layout` (no full-viewport chrome or column padding)
 * @param {string} [props.className]
 * @param {string} [props.contentClassName]
 * @param {string} [props.sideClassName]
 */
class SplitLayout extends Inherit(SplitLayoutController, Component) {
    render() {
        const {
            className,
            children,
            contentClassName,
            sideClassName,
            side,
            sideVariant = SplitLayoutSide.RIGHT,
            variant = SplitLayoutVariant.EQUAL,
            embedded = false,
        } = this.props;

        const _contentClassName = this.getContentColumnClassNames(contentClassName);
        const _sideClassName = this.getSideClassNames(sideClassName);
        const rootClass = this.getRootClassNames(className, variant, sideVariant, embedded);

        return (
            <div className={rootClass}>
                <div className={_contentClassName}>
                    {children}
                </div>
                <div className={_sideClassName}>{side}</div> 
            </div>
        );
    }
}

export default SplitLayout;

